<section class="users-edit" *ngIf="currentUrl == 'edit-batch/:id'">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- Nav-tabs -->
            <ul
              ngbNav
              #nav="ngbNav"
              [activeId]="1"
              class="nav-tabs justify-content-left"
            >
              <li [ngbNavItem]="1">
                <a ngbNavLink class="nav-link d-flex align-items-center">
                  <i class="ft-user mr-1"></i>
                  <span class="d-none d-sm-block">Account</span>
                </a>
                <ng-template ngbNavContent>
                  <div class="mt-2" id="account">
                    <form>
                      <div class="row">
                        <div class="col-md-6">
                          <fieldset class="form-group">
                            <label for="name">Name</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="batchData.name"
                              [ngModelOptions]="{ standalone: true }"
                              id="name"
                              placeholder="Enter Name"
                              #name
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Course</label>
                            <ng-select
                              [items]="courselist"
                              bindLabel="title"
                              bindValue="_id"
                              [closeOnSelect]="false"
                              placeholder="Select Course"
                              [(ngModel)]="selectedValue"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getCourseById($event)"
                            >
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="start_date">Start date</label>
                            <input
                              type="date"
                              class="form-control"
                              [(ngModel)]="batchData.start_date"
                              [ngModelOptions]="{ standalone: true }"
                              id="start_date"
                              placeholder="Enter Start Date"
                              #start_date
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="startTime"> Start Time</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="batchData.start_time"
                              [ngModelOptions]="{ standalone: true }"
                              name="startTime"
                              placeholder="Enter Course Fee"
                              #startTime
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="end_time">End Time</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="batchData.end_time"
                              [ngModelOptions]="{ standalone: true }"
                              name="end_time"
                              placeholder="Enter End  Time"
                              #end_time
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="fees">description</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="batchData.description"
                              [ngModelOptions]="{ standalone: true }"
                              id="noOfSeats"
                              placeholder="Enter Description"
                              #noOfSeats
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="days">Days</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="batchData.days"
                              [ngModelOptions]="{ standalone: true }"
                              id="days"
                              placeholder="Enter Days"
                              #days
                            />
                          </fieldset>
                        </div>
                        <div class="col-md-6">
                         
                          <fieldset class="form-group">
                            <label for="instructor">Instructor</label>
                            <ng-select [items]="usersList" bindLabel="name" bindValue="_id" placeholder="Select Instructor"
                              [(ngModel)]="selected_user" [ngModelOptions]="{ standalone: true }"
                              (change)="getSelectUserId($event)">
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Mode</label>
                            <ng-select
                              [items]="learningList"
                              bindLabel="displayname"
                              bindValue="_id"
                              placeholder="Select Learning Mode"
                              [(ngModel)]="learningMode"
                              [ngModelOptions]="{ standalone: true }"
                              (change)="getLearningId($event)"
                            >
                            </ng-select>
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="joining_link">Joining Link</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="batchData.joining_link"
                              [ngModelOptions]="{ standalone: true }"
                              id="joining_link"
                              placeholder="Enter Joining Link"
                              #joining_link
                            />
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="max_student">Max Student</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="1"
                              class="form-control"
                              [(ngModel)]="batchData.max_student"
                              [ngModelOptions]="{ standalone: true }"
                              id="max_student"
                              placeholder="Enter Max Student"
                              #max_student
                            ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Specail Notes</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="1"
                              class="form-control"
                              [(ngModel)]="batchData.specailnotes"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="Enter Specail Notes"
                            ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="notes"> Notes</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="1"
                              class="form-control"
                              [(ngModel)]="batchData.notes"
                              [ngModelOptions]="{ standalone: true }"
                              id="notes"
                              placeholder="Enter Notes"
                              #notes
                            ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label for="admin_notes"> Admin Notes</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="1"
                              class="form-control"
                              [(ngModel)]="batchData.admin_notes"
                              [ngModelOptions]="{ standalone: true }"
                              id="admin_notes"
                              placeholder="Enter Admin Notes"
                              #admin_notes
                            ></textarea>
                          </fieldset>
                          <div
                            class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                          >
                            <button
                              type="submit"
                              class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                              (click)="updateBatch()"
                            >
                              Submit
                            </button>
                            <button
                              type="reset"
                              class="btn btn-secondary"
                              (click)="back()"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </ng-template>
              </li>
            </ul>
            <div class="tab-content">
              <div [ngbNavOutlet]="nav"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section *ngIf="currentUrl =='edit-batch-audit/:id'">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <ul
              ngbNav
              #nav="ngbNav"
              [activeId]="1"
              class="nav-tabs justify-content-left"
            >
              <li [ngbNavItem]="1">
                <a ngbNavLink class="nav-link d-flex align-items-center">
                  <i class="ft-user mr-1"></i>
                  <span class="d-none d-sm-block">Account</span>
                </a>
                <ng-template ngbNavContent>
                  <div class="mt-2" id="account">
                    <form>
                      <div class="row">
                        <div class="col-md-6">
                          <fieldset class="form-group">
                            <label>Activity</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="1"
                              class="form-control"
                              [(ngModel)]="batchData.activity.description"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="Enter activity"
                            ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Student Overview</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="1"
                              class="form-control"
                              [(ngModel)]="batchData.student_overview.description"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="Enter student overview"
                            ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Rating</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="1"
                              class="form-control"
                              [(ngModel)]="batchData.rating.description"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="Enter rating"
                            ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Placement</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="1"
                              class="form-control"
                              [(ngModel)]="batchData.placement.description"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="Enter placement"
                            ></textarea>
                          </fieldset>
                        </div>
                        <div class="col-md-6">
                        
                          <fieldset class="form-group">
                            <label>Tesimonial</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="1"
                              class="form-control"
                              [(ngModel)]="batchData.tesimonial.description"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="Enter tesimonial"
                            ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Certification</label>
                            <textarea
                              id="hidden-label-form-6"
                              rows="1"
                              class="form-control"
                              [(ngModel)]="batchData.certification.description"
                              [ngModelOptions]="{ standalone: true }"
                              id="notes"
                              placeholder="Enter certification"
                              #notes
                            ></textarea>
                          </fieldset>
                          <fieldset class="form-group">
                            <label>Alert</label>
                            <ng-select
                            [items]="alert_list"
                            bindLabel="name"
                            color="is_activated"
                            bindValue="id"
                            placeholder="Select Alert"
                            [(ngModel)]="alert_event"
                            [ngModelOptions]="{ standalone: true }"
                            (change)="selectAlert($event)" 
                            >
                            </ng-select>
                        </fieldset>
                          <div
                            class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                          >
                            <button
                              type="submit"
                              class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                              (click)="updateBatch()"
                            >
                              Submit
                            </button>
                            <button
                              type="reset"
                              class="btn btn-secondary"
                              (click)="back()"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </ng-template>
              </li>
            </ul>
            <div class="tab-content">
              <div [ngbNavOutlet]="nav"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
